var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSplit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.034 12.993a2.46 2.46 0 002.205 2.103c2.174.199 4.437.432 6.761.432 2.325 0 4.588-.233 6.761-.432a2.46 2.46 0 002.205-2.103c.226-1.61.463-3.28.463-4.993 0-1.712-.237-3.382-.463-4.993A2.46 2.46 0 0016.76.904c-2.173-.198-4.436-.432-6.76-.432-2.325 0-4.588.234-6.762.432a2.46 2.46 0 00-2.205 2.103C.808 4.617.572 6.287.572 8c0 1.712.236 3.383.462 4.993zM13.143.597V15.41M6.857.597V15.41"
  })));
}
export default SvgSplit;